import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { FadeUp, Stagger, StaggerItem } from "../components/Reveal";
import { ServiceCards } from "../components/ServiceCards";
import { PILLARS } from "../data/content";

export default function HowWeHelp() {
    return (
        <div data-testid="how-we-help-page">
            <Seo
                title="How We Help | GrowVise"
                description="Two ways to work with GrowVise: an ongoing Advisory Retainer or hands-on Implementation Projects, for NZ retail, wholesale and distribution businesses."
                path="/how-we-help"
            />

            {/* Header — navy */}
            <section className="bg-navy-950 pt-32 sm:pt-40 pb-16 sm:pb-20" data-testid="hwh-hero">
                <div className="max-w-6xl mx-auto px-5 sm:px-8">
                    <FadeUp>
                        <p className="eyebrow">How We Help</p>
                        <h1 className="mt-6 font-serif font-semibold text-white tracking-tight leading-[1.15] text-4xl sm:text-5xl max-w-2xl">
                            Commercial growth is a system, not a slogan.
                        </h1>
                        <p className="mt-6 text-base sm:text-lg text-slate-300/90 leading-relaxed max-w-xl">
                            Most growing product businesses don't have a sales problem or a margin problem or a people problem. They have a system problem. We look at the commercial areas together — because that's how the business actually works.
                        </p>
                        <div className="mt-9 flex flex-wrap items-center gap-x-8 gap-y-4">
                            <Link to="/book-a-conversation" className="btn-gold" data-testid="hwh-book-cta">
                                Book a Growth Conversation
                            </Link>
                            <Link to="/business-health-check" className="inline-flex items-center gap-2 text-sm font-medium text-gold-400 hover:text-gold-300 transition-colors duration-200" data-testid="hwh-healthcheck-cta">
                                Try the free Health Check <ArrowRight size={15} />
                            </Link>
                        </div>
                    </FadeUp>
                </div>
            </section>

            {/* Six areas — white editorial list */}
            <section className="section-pad bg-white" data-testid="hwh-areas">
                <div className="max-w-6xl mx-auto px-5 sm:px-8">
                    <FadeUp className="max-w-xl mb-14">
                        <p className="eyebrow-light">The six commercial areas</p>
                        <h2 className="mt-5 font-serif font-semibold text-ink tracking-tight leading-snug text-3xl sm:text-4xl">
                            Where we look, every time.
                        </h2>
                    </FadeUp>
                    <Stagger>
                        {PILLARS.map((p, i) => (
                            <StaggerItem key={p.id}>
                                <div className="grid sm:grid-cols-[70px_240px_1fr] gap-3 sm:gap-8 py-7 border-t border-navy-900/10 items-baseline" data-testid={`hwh-area-${p.id}`}>
                                    <p className="font-serif font-semibold text-3xl text-navy-900/15">{String(i + 1).padStart(2, "0")}</p>
                                    <h3 className="font-serif font-semibold text-ink text-xl">{p.label}</h3>
                                    <p className="text-warmgrey leading-relaxed">{p.desc}</p>
                                </div>
                            </StaggerItem>
                        ))}
                    </Stagger>
                </div>
            </section>

            {/* Offers — cream */}
            <section className="section-pad bg-cream border-t border-navy-900/10" data-testid="hwh-offers">
                <div className="max-w-6xl mx-auto px-5 sm:px-8">
                    <FadeUp className="max-w-xl">
                        <p className="eyebrow-light">Advisory Retainers &amp; Implementation Projects</p>
                        <h2 className="mt-5 font-serif font-semibold text-ink tracking-tight leading-snug text-3xl sm:text-4xl">
                            Two services. Choose the one that fits, or combine them.
                        </h2>
                    </FadeUp>
                    <ServiceCards className="mt-14" />
                </div>
            </section>
        </div>
    );
}
